<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-08 16:30:13
 * @LastEditors: liyong
 * @LastEditTime: 2022-08-03 16:04:59
-->
<template>
	<div>
		<p class="fz-16 yx-color-text-primary yx-pingfang-semibold flex-row flex-align-center"
			><platform-icon :platformId="row.platform_id" size="16" class="mr-4"></platform-icon>{{ row.pallet_name }}</p
		>
		<p class="fz-14 yx-color-text-regular">货盘表ID: {{ row.id }}</p>
		<p class="fz-14 yx-color-text-regular">上传人: {{ row.partner_name }}</p>
		<p class="fz-14 yx-color-text-regular">上传时间: {{ row.add_time }}</p>
	</div>
</template>
<script>
import mixin from './mixin';
export default {
	mixins: [mixin],
	components: {},
};
</script>